export class OrderDetail {
   constructor(product_id, product, pieces, boxes, subtotal, iva, ieps, cost, discount, discountbyAmount, isGift = false){
      this.product_id = product_id
      this.product = product
      this.pieces = pieces
      this.boxes = boxes
      this.subtotal = subtotal
      this.iva = iva
      this.ieps = ieps
      this.cost = cost
      this.discount = discount
      this.discountbyAmount = discountbyAmount
      this.isGift = isGift
   }

   /**
    * Copy data
    * @param {OrderDetail} from
    * @param {OrderDetail} to 
    */
   static copyData(from, to){
      to.product_id = from.product_id
      to.product = from.product
      to.pieces = from.pieces
      to.boxes = from.boxes
      to.subtotal = from.subtotal
      to.iva = from.iva
      to.ieps = from.ieps
      to.cost = from.cost
      to.discount = from.discount
      to.discountbyAmount = from.discountbyAmount
      to.isGift = from.isGift
   }
}